module.exports = __webpack_public_path__ + "img/state-of-survival.286f550.png";